import {
  FETCH_TAGS_LIST_SUCCESS,
  FETCH_TAGS_LIST_FAILURE,
} from './actionTypes';

const initialState = {
  letter: null,
  tagsList: [],
};

export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TAGS_LIST_SUCCESS:
      return {
        letter: action.letter,
        tagsList: action.tagsList,
      };
    case FETCH_TAGS_LIST_FAILURE:
      return {
        ...initialState,
      };
  }
  return state;
}
